import { useEffect, useState } from 'react';

import { GhostPostsOrPages } from '../utils/api/ghost/ghost-interfaces';
import { getPagesForAsset } from '../utils/api/ghost/pages/getPageForAsset';

type Error = {
    message: string;
};

/**
 * Fetches asset pages from ghost
 */
const useGhostAssetPages = (assetCode: string, pageId: string = 'overview') => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<Error | null>(null);
    const [assetPages, setAssetPages] = useState<GhostPostsOrPages | null>(null);

    useEffect(() => {
        setIsLoading(true);

        const fetchData = async () => {
            getPagesForAsset(assetCode, pageId, 'title ASC').then(pages => {
                if (!pages) {
                    setError({ message: 'Error fetching pages.' });
                    setIsLoading(false);
                    return;
                }

                setIsLoading(false);
                setAssetPages(pages);
                setError(null);
            });
        };

        fetchData();
    }, [assetCode, pageId]);

    return { assetPages, assetPagesError: error, isLoading };
};

export default useGhostAssetPages;
